import React from 'react';
import { motion } from 'framer-motion';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
export function IngredientsCta() {
  const gclid = useGclid();
  const href = buildShopUrl(SHOP_URL, gclid);
  return <section className="w-full py-12 px-4" data-id="element-126">
      <div className="max-w-2xl mx-auto text-center" data-id="element-127">
        <motion.a initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} href={href} onClick={() => trackCTAClick('Jetzt für meinen Hund bestellen', 'ingredients_cta')} target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-forest hover:bg-forest-light text-white font-serif font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-128">
          Jetzt für meinen Hund bestellen
        </motion.a>
      </div>
    </section>;
}